import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'PhonePipe' })
export class PhonePipe implements PipeTransform {

    transform(txt: string): string {

        if (txt === null || txt.trim() === '') return '';

        txt = txt.replace(/([^0-9])/g, '').trim();

        if (txt.length > 2 && txt.substr(0, 2) === "84") {
            txt = "0" + txt.substr(2);
        }
        else if (txt.length > 3 && txt.substr(0, 3) === "+84") {
            txt = "0" + txt.substr(3);
        }
        else if (txt[0] != '0') {
            txt = "0" + txt;
        }

        let parts = [];
        if (txt.length > 3) {
            parts.push(txt.substr(0, 3));
            txt = txt.substr(3);

            if (txt.length > 3) {
                parts.push(txt.substr(0, 3));
                txt = txt.substr(3);

                if (txt.length > 2) {
                    parts.push(txt.substr(0, 2));
                    txt = txt.substr(2);
                }
            }
        }

        if (txt.length > 0) {
            parts.push(txt);
        }

        return parts.join(' ');
    }
}
